import { useMutation } from '@tanstack/react-query';
import { PinItemRequest } from '@/types/request/PinItemRequest';
import { BackendSuccessResponse } from '@/types/response/Api/BackendSuccessResponse';
import { BackendErrorResponse } from '@/types/response/Api/BackendErrorResponse';
import { queryClient } from '@/main.tsx';
import BackendClient from '@/api/backendClient.ts';
import { transformBackendErrors } from '@/utils/transformBackendErrors.ts';

const usePinItem = () => {
  const mutationFn = async (request: PinItemRequest) => {
    return pinItem(request);
  };

  return useMutation({
    mutationFn,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['pinned_items'] });
    },
  });
};

export default usePinItem;

async function pinItem(request: PinItemRequest): Promise<void> {
  try {
    await BackendClient.post<BackendSuccessResponse<void>>('/api/chat/pin', request);

    return;
  } catch (error: any) {
    if (error.response && error.response.data) {
      const errorResponse = error.response.data as BackendErrorResponse;

      throw new Error(transformBackendErrors(errorResponse).join(', '));
    }

    throw new Error(error.message ?? 'An error occurred while pinning item.');
  }
}
